module.exports = __webpack_public_path__ + "img/vrsmash.fc2a781e.jpg";